import * as z from "zod/v4";

const WorkflowStateSchema_ = z.object({
  id: z.string(),
  name: z.string(),
  color: z.string(),
  type: z.string(),
});

export const WorkflowStateSchema: z.ZodType<WorkflowState> =
  WorkflowStateSchema_;
export interface WorkflowState extends z.infer<typeof WorkflowStateSchema_> {}

export const getLinearWorkflowStates = {
  name: "getLinearWorkflowStates" as const,
  input: z.object({}),
  output: z.object({ states: z.array(WorkflowStateSchema) }),
};
